<template>
    <div class="inline-block">
        <div v-if="formOpen === false">
            <template v-if="isEdit">
                <button
                    type="button"
                    @click="open()"
                    class="inline-flex items-center px-1.5 py-1.5 border border-transparent text-xs font-medium rounded text-indigo-700 bg-indigo-100 hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                    <svg viewBox="0 0 20 20" fill="currentColor" class="pencil w-4 h-4">
                        <path
                            d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z"
                        ></path>
                    </svg>
                </button>
            </template>
            <template v-else>
                <button type="button" @click="open()" class="flex items-center space-x-2">
                    <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <path
                            fill-rule="evenodd"
                            d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                            clip-rule="evenodd"
                        ></path>
                    </svg>

                    {{ $tc('messages.qualitative_report_items', 1) }}
                </button>
            </template>
        </div>
        <template v-else>
            <component :is="isEdit ? 'Modal' : 'span'" :show="formOpen" @close="formOpen = false">
                <form :action="endpoint.url" method="post" @submit.prevent="submit">
                    <div class="flex space-x-2 items-center" :class="isEdit ? 'justify-between' : ''">
                        <div class="mt-1 w-full">
                            <FormLabel
                                :value="$tc('messages.qualitative_report_items', 1)"
                                for="name"
                                class="sr-only"
                            />
                            <FormInput
                                required
                                id="name"
                                v-model="form.name"
                                name="name"
                                ref="name"
                                type="text"
                                :placeholder="$tc('messages.qualitative_report_items', 1)"
                                max="180"
                                class="mt-1 w-full"
                            />
                            <FormError :value="form.errors.name" class="mt-2" />
                        </div>

                        <div class="shrink-0">
                            <AppButton desired-action element="button" type="submit" :disabled="form.processing">
                                {{ $t('messages.save') }}
                                <span v-if="form.processing" class="ml-1 btn-spinner" />
                            </AppButton>

                            <AppButton element="button" type="button" @click="formOpen = !formOpen">
                                {{ $t('messages.cancel') }}
                            </AppButton>
                        </div>
                    </div>
                </form>
            </component>
        </template>
    </div>
</template>

<script>
import FormError from '@/components/Forms/FormError.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import AppButton from '@/components/AppButton.vue';
import Modal from '@/components/Modal.vue';

export default {
    name: 'QualitativeReportItemForm',
    components: {
        FormLabel,
        FormInput,
        FormError,
        AppButton,
        Modal,
    },
    props: {
        endpoint: {
            type: Object,
            required: true,
        },
        isEdit: {
            type: Boolean,
            default: false,
        },
        item: {
            type: Object,
            required: false,
            default: () => ({
                name: '',
            }),
        },
    },
    data() {
        return {
            formOpen: false,
            form: this.$inertia.form({
                name: this.item.name,
            }),
        };
    },
    methods: {
        submit() {
            this.form.submit(this.endpoint.method, this.endpoint.url, {
                onSuccess: () => {
                    this.form.reset('name');
                    this.formOpen = false;
                },
                preserveScroll: true,
            });
        },
        cancel() {
            this.formOpen = false;
            this.form.reset('name');
            this.form.clearErrors();
        },
        open() {
            this.formOpen = true;
            this.focusInput();
        },
        focusInput() {
            this.$nextTick(function () {
                this.$refs.name.focusInput();
            });
        },
        onEscape(e) {
            if (e.key === 'Esc' || e.key === 'Escape') {
                this.open = false;
            }
        },
    },
    beforeUnmount() {
        document.removeEventListener('keydown', this.onEscape);
    },
    mounted() {
        document.addEventListener('keydown', this.onEscape);
    },
};
</script>
